import { Locale } from '@libs/core';

const {
    DOORDASH_SIGNING_SECRET_US,
    DOORDASH_KEY_ID_US,
    DOORDASH_DEVELOPER_ID_US,
    DOORDASH_SIGNING_SECRET_CA,
    DOORDASH_KEY_ID_CA,
    DOORDASH_DEVELOPER_ID_CA,
} = process.env;

export const DOOR_DASH_API_URL = 'https://openapi.doordash.com/drive/v1/';
export const DOOR_DASH_API_ESTIMATE = 'estimates';
export const DOOR_DASH_API_VALIDATIONS = 'validations';

export const ENV_VARIABLES = {
    [Locale['en-US']]: {
        DOORDASH_SIGNING_SECRET: DOORDASH_SIGNING_SECRET_US,
        DOORDASH_KEY_ID: DOORDASH_KEY_ID_US,
        DOORDASH_DEVELOPER_ID: DOORDASH_DEVELOPER_ID_US,
    },
    [Locale['en-CA']]: {
        DOORDASH_SIGNING_SECRET: DOORDASH_SIGNING_SECRET_CA,
        DOORDASH_KEY_ID: DOORDASH_KEY_ID_CA,
        DOORDASH_DEVELOPER_ID: DOORDASH_DEVELOPER_ID_CA,
    },
};
